/// <reference path="../../../typings/index.d.ts" />
/// <reference path="../apimodel.d.ts" />

module App.Common {

	export class WindowBroadcastMessage {

		public timestamp: number;

		constructor(
			public sourceWindowId: string,
			public eventName: string,
			public data: any = null
		) {
			this.timestamp = Date.now();
		}

	}

}